import _ from "lodash";
import React, { useState } from "react";
import UIModal from "UIComponents/UIModal";
import I18nHOC from "UIComponents/I18nHOC";
import withLoader from "UIComponents/GqlWithLoader";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import { compose, graphql } from "lib/apolloClient";
import { connect } from "react-redux";

import classes from "./FamilyInviteChildSelection.scss";
import { Button } from "@toddle-edu/ds-web";
import { markStudentAsRequestedForFamilyInvite } from "Courses/modules/CoursesModule";
import ApprovalRequestSentModal from "./components/ApprovalRequestSentModal";
import StudentContent from "./components/StudentContent";
import { getChildrenQuery } from "modules/CommonQuery";
import { getChildrenFromCache } from "modules/CommonGraphqlHelpers";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";

const FamilyInviteChildSelection = props => {
  const {
    t,
    onClose,
    allChildren,
    courseId,
    onChildChangeClick,
    markStudentAsRequestedForFamilyInvite,
  } = props;

  const [selectedStudent, setSelectedStudent] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [approvalRequestSentModal, setApprovalRequestSentModal] = useState(
    false
  );
  const [isLoading, setLoading] = useState(false);

  const handleSelectionChange = id => setSelectedStudent(id);

  const handleSubmit = async () => {
    setLoading(true);
    await markStudentAsRequestedForFamilyInvite({
      courseId,
      childIds: [selectedStudent?.id],
    });
    setLoading(false);
    setApprovalRequestSentModal(true);
  };

  const onConfirmClose = () => {
    onClose();
    // this function is called from the parent home page and this
    // shows the portal for this latest selected student
    if (_.get(selectedStudent, "id") && onChildChangeClick) {
      onChildChangeClick(_.get(selectedStudent, "id"));
    }
  };

  const onDismissInvitation = () => {
    onClose();
  };

  if (approvalRequestSentModal) {
    return (
      <ApprovalRequestSentModal
        student={selectedStudent}
        onClose={onConfirmClose}
      />
    );
  }

  return (
    <UIModal isOpen={true} modalContent={classes.modalContent}>
      <div className={classes.contentWrapper}>
        <div className={classes.container}>
          <StudentContent
            handleSelectionChange={handleSelectionChange}
            selectedStudent={selectedStudent}
            courseId={courseId}
            allChildren={allChildren}
            searchText={searchText}
            setSearchText={setSearchText}
            onClose={onClose}
          />
        </div>
        <div className={classes.footer}>
          <div className={classes.footerWrapper}>
            <Button
              onClick={onDismissInvitation}
              className={classes.cancel}
              variant="outlined-subtle"
              size="large"
            >
              {t("common:dismiss_invitation")}
            </Button>
            <Button
              disabled={selectedStudent === null || isLoading}
              className={classes.confirm}
              variant="progressive"
              size="large"
              onClick={handleSubmit}
            >
              {t("common:confirm_selection")}
            </Button>
          </div>
        </div>
        {isLoading && <FullScreenLoader />}
      </div>
    </UIModal>
  );
};

const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const courseId = ownProps.courseId;
  const userId = userInfo.id;
  const childrenDataPresent = ownProps.childrenDataPresent;

  return {
    courseId,
    userId,
    isData: true,
    isLoading: false,
    childrenDataPresent,
  };
};

const mapActionCreators = { markStudentAsRequestedForFamilyInvite };

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["integration", "common"] }),
  graphql(getChildrenQuery, {
    name: "getChildren",
    options: ({ userId, portalType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: userId,
        type: "FAMILY_MEMBER",
      },
    }),
    skip: ({ childrenDataPresent }) => childrenDataPresent,
    props({ getChildren, ownProps: { userId, portalType } }) {
      const childrenData = getChildrenFromCache({
        id: userId,
        type: "FAMILY_MEMBER",
      });
      const children = _.get(childrenData, "children", []);

      return {
        allChildren: children,
      };
    },
  }),
  withLoader
)(FamilyInviteChildSelection);
